import { Card, Result, Button } from 'antd';
import { CloseCircleTwoTone, ReloadOutlined } from '@ant-design/icons';


export const ErrorFallback = ({ error, resetErrorBoundary }) => {
    const handleReload = () => {
        resetErrorBoundary()
        window.location.reload();
    }
    return (
        <div className="flex items-center justify-center min-h-screen bg-linear-to-br from-blue-100 to-purple-100 p-6">
            <div>
                <Card className="w-full max-w-lg shadow-2xl rounded-2xl border-0">
                    <Result
                        status="error"
                        title={<span className="text-2xl font-semibold text-red-600">Rất tiếc, đã xảy ra lỗi!</span>}
                        subTitle={
                            <pre className="text-sm text-gray-700 whitespace-pre-wrap break-words mt-2">
                                {error.message}
                            </pre>
                        }
                        icon={<CloseCircleTwoTone twoToneColor="#ff4d4f" style={{ fontSize: '64px' }} />}
                        extra={
                            <Button
                                type="primary"
                                icon={<ReloadOutlined />}
                                size="large"
                                onClick={handleReload}
                                className="bg-blue-500 hover:bg-blue-600 transition-colors duration-300"
                            >
                                Thử tải lại
                            </Button>
                        }
                    />
                </Card>
            </div>
        </div>
    )
}